import React, { useEffect, useState } from "react";
import { AdaptiveCardElement } from "../templates/AdaptiveCardElement"
import { platformService } from "../shared/services/platform.service";

interface Props {
    msgType?:string;
}

export const ScopeErrorMessage = (prop: Props) => {
    const [errorMsg, setErrorMsg]  = useState("");
    useEffect(()=>{
        (async () => {
            //msgType => Kb, Template, NoAccess
            const api = new platformService();
            let {data : {value}} = await api.getScopedErrorMessageCard(prop.msgType ?? "Template");
            setErrorMsg(value);
        })();
    },[]);
    return (<AdaptiveCardElement jsonString={errorMsg} cardProps={{ styles: { height: 'fit-content' } }}
                containerClassName={`AdaptiveCardElementValidationClass`}
                  isEndUserPage={true}
              />);
}